<template>
  <div>
    <div class="life_list">
      <div class="life_box" @click="todetail(index)" v-for="(item,index) in storeList">
        <div class="lifebox_left">
          <img class="life_img" :src="item.thumb" />
          <div class="life_des">{{item.name}}</div>
        </div>
        <img class="life_to" src="/static/xiangyou.png" />
      </div>
    </div>
   <!--   <img src="/static/maoyan.jpg" /> -->
  </div>
</template>

<script>
  import httper from '../../api/http';
  export default {
    data() {
      return {
 storeList: [], //接口获取商品列表

      }
    },
    created() {
if (this.$route.query.cate_id) {
        this.request("getstoreList", {
          cate_id: this.$route.query.cate_id
        })
      }
    },
    mounted() {

    },
    methods: {
      // todetail(e) {
      //   this.$router.push({
      //     path: "/lifeDetail",
      //     query: {
      //       lifeDetailId: e
      //     }
      //   })
      // },
      todetail(e) {

        this.$router.push({
          path: '/lifeDetail',
          query: {
            id:this.storeList[Number(e)].id
          }
        })
      },
      //调接口封装
      request(type, requestData = {}) {
        let that = this
        switch (type) {
            //获取商品列表
          case 'getstoreList':
            httper.get('product/get-online-by-cate', requestData, res => {
              if (res.code === 0) {
                console.log("商品列表", res)
                this.storeList = res.data
              } else {
                this.$toast({
                  message: res.message
                })
              }
            })
            break
        }
      },
    }
  }
</script>

<style>
  .life_list {
    margin: 20px;
  }

  .life_box {
    width: 95%;
    height: 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    border: 1px solid #dedede;
    margin-bottom: 20px;
    /* background-image: url(../../../static/aiqiyibanner.png); */
  }

  .lifebox_left {
    display: flex;
    align-items: center;
  }

  .life_img {
    width: 50px;
    height: 50px;
    border-radius: 25px;
    margin: 10px;
  }

  .life_des {}

  .life_to {
    width: 35px;
    height: 35px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/life/lifeList.vue